/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppLoaderComponent } from './app-loader.component';
import { AppLoaderRoutingModule } from '@app/components/app-loader/app-loader-routing.module';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { FrameComponent } from './frame/frame.component';
import { ImageViewerModule } from '@app/components/image-viewer/image-viewer.module';
import { FormsModule } from '@angular/forms';
import { IframeResizerDirectiveModule } from '@app/directives/iframe-resizer-directive/iframe-resizer-directive.module';

@NgModule({
  declarations: [AppLoaderComponent, FrameComponent],
  exports: [AppLoaderComponent, FrameComponent],
  imports: [
    CommonModule,
    AppLoaderRoutingModule,
    NgxUiLoaderModule,
    ImageViewerModule,
    FormsModule,
    IframeResizerDirectiveModule,
  ],
})
export class AppLoaderModule {}
